import React from "react";
import { App } from "../../application";
import { createRoot } from "react-dom/client";
import { Store } from "webext-redux";
import { Provider } from "react-redux";
import { store as defaultStore, persistor } from "../../common/store";
import { PersistGate } from "redux-persist/integration/react";
import { rootId } from "../../common/constants/root-id";
import { BrowserRouter } from "react-router-dom";

import  "script-loader!./vurbalize.js";

let domElement = document.getElementById(rootId);

if (!domElement) {
  domElement = document.createElement("div");
  domElement.id = rootId;
  domElement.classList.add(rootId);

  domElement = document.body.appendChild(domElement);
}

const root = createRoot(domElement);

let store: Store;

switch (process.env.APP_TYPE) {
  case "application":
    store = defaultStore as Store;

    root.render(
      <Provider store={store}>
        <PersistGate loading={<div>123</div>} persistor={persistor}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    );
  break;
  case "extension":
    store = defaultStore as Store;

    root.render(
      <Provider store={store}>
        <PersistGate loading={<div>123</div>} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    );
  break;

  default: 
  throw new Error(`unexpected APP_TYPE`)
}

